import "../css/package.css";
import { Card, Col, Container, Row } from "react-bootstrap";
import rice from "../assets/rice.jpg";
import dal from "../assets/daal.jpg";
import sabji from "../assets/specialsabji.jpg";
import specialsabji from "../assets/specialsabji1.jpg";
import roti from "../assets/roti.png";
import puri from "../assets/puri.jpg";
import dahiwada from "../assets/dahiwada.jpeg";
import manchurian from "../assets/manchurian.jpg";
import mirchibhaje from "../assets/mirchibhaje.jpg";
import salad from "../assets/sala.jpg";

function SilverPackage() {
  const dishes = [
    { title: "Rice", img: rice, items: ["Jira Rice", "Plain Rice", "Masala Rice"] },
    { title: "Dal", img: dal, items: ["Dal Fry", "Dal Bhaji", "Simple Dal"] },
    { title: "Sabji", img: sabji, items: ["Masala Baigan", "Patodi", "Dum Aaloo"] },
    { title: "Special Sabji", img: specialsabji, items: ["Mix Veg", "Paneer Butter Masala", "Paneer Watana"] },
    { title: "Roti", img: roti, items: ["Fulka Roti (on Spot)", "Sadi Roti", "Oil Roti"] },
    { title: "Puri", img: puri, items: ["Palak Puri", "Masala Puri", "Sadgi Puri"] },
    { title: "Curd Dishes", img: dahiwada, items: ["Dahi Wada", "Dahi Kadi", "Bundi Matha"] },
    { title: "Starter", img: manchurian, items: ["Noodles", "Manchurian", "M.S.Dosa"] },
    { title: "Special Dish", img: mirchibhaje, items: ["Moong Pakoda", "Kande Bhaje", "Mirchi Bhaje"] },
    { title: "Salad", img: salad, items: ["Green Salad", "Aachar & Papad", "Filter Water"] },
  ];

  return (
    <Container className="silver-section">
      <p style={{
        fontSize: "24px",
        fontWeight: "bold",
        textAlign: "center",
        marginBottom: "30px",
      }}>
        Silver Package of Rs 1,00,000/- for 500 Guests (Hall / Lawn + Catering)
      </p>

      <Row className="g-4">
        {dishes.map((dish, index) => (
          <Col key={index} xs={12} sm={6} md={4} lg={3} style={{
          }}>
            <Card className="silver-card h-100">
              <Card.Img variant="top" src={dish.img} className="silver-img" />
              <Card.Body>
                <Card.Title className="silver-title">{dish.title}</Card.Title>
                {dish.items.map((item, i) => (
                  <p key={i} className="silver-item">{item}</p>
                ))}
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <h2 id="silvernote">Note: Extra Charges for Decoration</h2>

    </Container>
  );
}

export default SilverPackage;
